/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable import/no-cycle */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable no-confusing-arrow */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable operator-linebreak */
/* eslint-disable object-curly-newline */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-void */
/* eslint-disable no-alert */
/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-continue */
import React, { useState, useEffect } from "react";

import { useNavigate } from "react-router-dom";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import Environments from "../../../Environments";
import { CAREER_TYPE_ELEARNING, CAREER_TYPE_CLASSROOM } from "../../../Constants";
import MOCK_DATA from "../../../mock/data";

import NoData from "../../../component/NoData";
import CareerCard from "../../../component/card/CareerCard";
import SompoCardContent from "../../../component/card/SompoCardContent";
import FilterTag, { ALL_CONDITION } from "../../../component/filter/FilterTag";
import { useScreenSize } from "../../../component/Theme";
import { ReactSlickSetting, calcDotsHeight } from "../../../component/ReactSlickSettings";
import ConditionList from "../../../component/ConditionList";
import SompoDeadlineAlert from "../../../component/alert/SompoDeadlineAlert";
import SompoLoading from "../../../component/loading/SompoLoading";
import { HomeProps } from "../Home";

import { CareerResultsItem } from "../../../logic/api/SearchCareerClassListService";
import { CATEGORY_ID_CAREERS } from "../../../logic/hook/useCategories";
import { formatPeriod, diffDay, parseJSDate, parseJSDateTime, DateFormats, currentDate } from "../../../logic/datetime";
import { alertDaysForSearchCareer } from "../../../logic/utility/searchCareerClassUtil";
import { descDate } from "../../../logic/utility/sort";
import SompoContext from "../../../logic/context/SompoContext";

const NewCourse = (props: HomeProps) => {
    const { categories, careers: homeCarrers } = props;
    const { getLevelCategories, getTargetCategory } = categories;
    const conditionList = ConditionList(getLevelCategories(CATEGORY_ID_CAREERS));

    const navigate = useNavigate();
    const { desktop } = useScreenSize();
    const [careers, setCareers] = useState<CareerResultsItem[]>([]);
    const sompoContext = React.useContext(SompoContext); // ローディングアニメーションの表示用

    const [filterValue, setFilterValue] = useState(ALL_CONDITION.id);
    const handleChange = (name: string, id: string) => {
        setFilterValue(id);
    };

    const reactSlickHeight = calcDotsHeight(330, (careers || []).length, 1);

    useEffect(() => {
        if (!Environments.MOCK) {
            const newCourse: CareerResultsItem[] = [];

            for (const item of homeCarrers || []) {
                if (filterValue !== ALL_CONDITION.id) {
                    const topCategories = getTargetCategory(item.careerId);
                    if (topCategories?.id !== filterValue) continue;
                }

                // 開催期間開始日がない場合、申請不可の場合はスルー
                if (!item.displayStartDateTime || !item.check) {
                    continue;
                }

                // 開催期間開始日と今日の日付を比較し、今日の日付-14日以内の講座のみ表示する
                const itemStartDate = parseJSDate(item.displayStartDateTime, DateFormats.YYYYMMDDHHMM);
                const nowDate = currentDate();
                const diff = diffDay(nowDate, itemStartDate!);
                if (!(diff >= 0 && diff <= 14)) {
                    continue;
                }

                newCourse.push(item);
            }

            const sortedStartDate = newCourse.sort((a, b) =>
                descDate(
                    parseJSDateTime(a.displayStartDateTime, DateFormats.YYYYMMDDHHMM),
                    parseJSDateTime(b.displayStartDateTime, DateFormats.YYYYMMDDHHMM)
                )
            );

            setCareers(sortedStartDate);
        } else {
            const _careers = MOCK_DATA.USER.RECOMMEND;
            setCareers(_careers);
        }
    }, [filterValue, homeCarrers]);

    return (
        <Box
            sx={{
                width: "100%",
                height: "auto",
                mt: desktop ? 4 : 0,
                minHeight: "200px",
                pointerEvents: sompoContext.loading ? "none" : "auto",
            }}
        >
            <Typography variant="h3" sx={{ mb: 1 }}>
                新着
            </Typography>

            {/* fetchが終わるまでローディングアイコンを表示 */}
            {sompoContext.loading ? (
                <SompoLoading mt={4} position="relative" />
            ) : (
                <>
                    <FilterTag conditionList={conditionList} value={filterValue} handleChange={handleChange} />

                    {careers && careers.length > 0 ? (
                        <Box sx={{ width: "100%", height: desktop ? "350px" : reactSlickHeight, margin: "0 auto" }}>
                            <Slider {...ReactSlickSetting}>
                                {careers.map((row, index) => {
                                    const el = row.careerTypeId === Number(CAREER_TYPE_ELEARNING);
                                    const gt = row.careerTypeId === Number(CAREER_TYPE_CLASSROOM);

                                    const { alertView, remainingDays } = alertDaysForSearchCareer(row);
                                    return (
                                        <CareerCard
                                            key={`Home-NewCourse-Career-Card-${row.careerId}-${row.classId}-${index}`}
                                            thumbnail={row.careerImageUrl}
                                            tooltip={row.careerTitle}
                                            badge={row.divisionId}
                                            onClick={() => {
                                                navigate(`/training/detail/${row.careerId}`, {
                                                    state: { check: false, showCertification: true, classId: row.classId },
                                                });
                                            }}
                                        >
                                            <SompoCardContent
                                                sx={{
                                                    height: "175px",
                                                    display: "flex",
                                                    gap: 0.4,
                                                    flexDirection: "column",
                                                    justifyContent: "flex-start",
                                                    textAlign: "left",
                                                }}
                                            >
                                                <Box />
                                                <Typography
                                                    sx={{
                                                        width: "100%",
                                                        fontSize: "1rem",
                                                        fontWeight: "bold",
                                                        minHeight: "2lh",
                                                        wordBreak: "break-all",
                                                        overflowX: "hidden",
                                                    }}
                                                    className="ellipses2"
                                                >
                                                    {row.careerTitle}
                                                </Typography>
                                                {el && <Typography variant="body2">eラーニング</Typography>}
                                                {gt && <Typography variant="body2">集合研修</Typography>}
                                                <SompoDeadlineAlert nearDeadline={alertView} diffDays={remainingDays} />
                                                <Typography
                                                    variant="body2"
                                                    sx={{
                                                        fontWeight: alertView ? "bold" : "normal",
                                                    }}
                                                >
                                                    {formatPeriod(row.period)}
                                                </Typography>

                                                {gt && (
                                                    <Typography
                                                        className="ellipses"
                                                        variant="body2"
                                                        sx={{ wordBreak: "break-all", overflowX: "hidden" }}
                                                    >
                                                        {row.placeName}
                                                    </Typography>
                                                )}
                                            </SompoCardContent>
                                        </CareerCard>
                                    );
                                })}
                            </Slider>
                        </Box>
                    ) : (
                        <NoData message="表示データがありません" />
                    )}
                </>
            )}
        </Box>
    );
};

export default NewCourse;
